var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"a433712e22ae865f96a9e2adf193993bc87915f5"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://1c01b930aa90ee265e06aa769c5874df@o4510928655417344.ingest.us.sentry.io/4510929880875008",

  // 環境ごとにトレース量を絞る（TWP-3882）。
  // 1.0 のままだとSentryのスパン枠を org 全体で食い潰す: 2026-07-28〜08-07 の11日間、
  // 枠超過でトレースが全件ドロップしていた（このプロジェクトも直近30日で
  // accepted 210,953 に対し rate_limited 204,573 が破棄されていた）。
  //
  // **プレビューだけを 0.05 にし、それ以外は 0.2 にしている。** 判別できない環境
  // （システム環境変数が露出していない・Docker/self-host）で低い側へ倒すと、本番の
  // トレースが無言で1/20になる。twp-front（TWP-3881）も「判別不能なら本番と同じ 0.2」で
  // 揃えている。語彙とサンプリングの正本は
  // twp-docs/infrastructure/sentry-environments.md。
  //
  // NEXT_PUBLIC_ を先に読むのはクライアントバンドルではビルド時置換が必要なため。
  // サーバ・edge では VERCEL_ENV が実行時に読めるのでフォールバックに置く。
  tracesSampleRate:
    (process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV) === "preview"
      ? 0.05
      : 0.2,

  // Define how likely Replay events are sampled.
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  integrations: [new Sentry.Replay()],

  ignoreErrors: [
    // Next.js Pages Router internal router issue when navigating to the same URL with query parameters/hash
    "Invariant: attempted to hard navigate to the same URL",
  ],
});
